
import React, { useEffect, useState } from "react";
import '../Searchfilter/Filter.css'
import Pagination from "./Pagination";
import SearchCard from "./SearchCard";
import { products } from './data'
import * as Product from "../../../network/api/product"

export default function Pag(props) {

    const query = window.location.pathname.split("/")[2];
    const [coinsData, setCoinsData] = useState([]);
    const [rates, setRates] = useState([]);
    const [products, setProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, setPostsPerPage] = useState(12);

    const getProducts = async () => {
        const decoded = decodeURIComponent(query);
        await Product.searchpage(decoded).then((response) => {
            setProducts(response.data.response);
            setRates(response.data.rates)
           
        });
    };

    useEffect(() => {
        getProducts()
        setCoinsData(products);
    }, []);

    return (
        <div className=''>
            <SearchCard products={products} rates={rates} personal={props.personal} update_p={props.update_p} coinsData={coinsData} />
            <Pagination
                totalPosts={coinsData.length}
                postsPerPage={postsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
            />
        </div>
    );
};
















// ظظظظظظظظظظظظظظظظظظظظظظظظظظظظظ
